export const userIsAllowed = (currentUser, actionIdList) => {
  //Use to know if the user has an action. The action should be allowable, becouse if it is admin it will always return true

  if (currentUser.roleId === 1) return true;

  return currentUser?.actions?.some((action) =>
    actionIdList.includes(action.actionId)
  );
};
